import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;
  onClick: () => void;
}

const SignInButton: React.FC<IProps> = ({ style, onClick }) => {
  return (
    <button className={'nes-btn is-primary'} style={style} onClick={onClick}>
      Sign in
    </button>
  );
};

export default SignInButton;
